import http from '../clients/Axios'

export default class JobService {
  async get() {
    const res = await http.get('/scheduler')
    return res.data
  }

  async sync(form) {
    const res = await http.post('/scheduler', form)
    return res
  }

  async stop() {
    const res = await http.post(`/scheduler/stop`)
    return res
  }

  async reset() {
    const res = await http.post(`/scheduler/reset`)
    return res
  }

  async getDB() {
    const res = await http.get('/scheduler/db')
    return res.data
  }

  async updateDB(form) {
    const res = await http.put('/scheduler/db', form)
    return res
  }

  async testDB() {
    const res = await http.get('/scheduler/test')
    return res
  }

  async updateAuto(form) {
    const res = await http.put(`/scheduler/auto`, form)
    return res
  }
}
